'use client';

// Admin binding for the shared connection-health bar (BL-1090).
// Per sharing.md § 1 the app keeps only this thin wrapper: the monitor lives in
// @auctogon/core/connection-health, the visual in @auctogon/ui/web.
//
// Replaces the per-surface ConnectionHealthBanner that the clerk console and
// the timed-controls dashboard each rendered. One app-wide bar means an
// operator can't be shown two competing connection surfaces, and recovery is
// automatic — the Resync button is gone (on the clerk console it was inert
// anyway: it bumped a `resyncKey` no consumer ever read).
//
// BL-2342: inside the phone app the offline mode's own bar replaces it (ADR
// 066 — Offline Mode § 5). This is the one place that choice is made.

import { ConnectionHealthBar } from '@auctogon/ui/web';
import { useConnectionHealth } from '@auctogon/core/connection-health';
import NativeConnectivityBar from '../offline/NativeConnectivityBar';
import { useOfflineMode } from '../offline/OfflineModeProvider';

/**
 * Render the connection bar for this surface: the phone app's connectivity bar
 * inside the app, the shared black bar everywhere else.
 *
 * @returns the bar, or nothing while the connection is healthy.
 */
export default function ConnectionHealthBarMount() {
    const { isOffline, isFeedDisconnected } = useConnectionHealth();
    const { isNativeApp } = useOfflineMode();
    if (isNativeApp) return <NativeConnectivityBar />;
    return (
        <ConnectionHealthBar
            isOffline={isOffline}
            isFeedDisconnected={isFeedDisconnected}
        />
    );
}
